



















































import gql from 'graphql-tag';
import Vue from 'vue';
import { filter, flow, map, pickBy, sortBy, keyBy, split } from 'lodash';
import { BTabs, BTab } from 'bootstrap-vue';
import ZenButton from '@reciprocity/button';
import LoadingSpinner from '@reciprocity/loading-spinner';
import SorTreeView from '@/graphql/listing/SorTreeView';

interface ObjectTypeMeta {
  [key: string]: string;
}

interface Configuration {
  filters: string;
  columns: Array<string>;
  pageSize: number;
}

// We get a recursion import error if we dont import like () => import
export default Vue.extend({
  name: 'TreeView',
  components: {
    SorListing: () => import('@/components/listing/SorListing.vue'),
    BTabs,
    BTab,
    LoadingSpinner,
    ZenButton,
  },
  props: {
    objectId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tabsList: [],
      objectTypeMeta: {} as ObjectTypeMeta,
      defaultPageSize: 20,
      pageSize: 20,
    };
  },
  computed: {
    loading(): boolean {
      return this.$apollo.queries.mappings.loading || this.$apollo.queries.tabsList.loading;
    },
  },
  methods: {
    config(objectType: string): Configuration {
      // TODO rewrite with filter interface when its implemented to accept "object name"
      const objectIdSplit = split(this.objectId, ':');
      let mappedFilter = {
        object_name: objectIdSplit[0],
        op: {
          name: 'relevant',
        },
        ids: [objectIdSplit[1]],
      };
      // TODO rewrite to set this in config meta
      const config = <Configuration>{};
      config.filters = JSON.stringify(mappedFilter);
      config.columns = objectType == 'Person' ? ['name', 'email'] : ['title'];
      config.pageSize = this.pageSize;
      return config;
    },
    pageSizeChange(pageSize: number) {
      this.pageSize = pageSize;
    },
    resetConfiguration(): void {
      this.pageSize = this.defaultPageSize;
    },
  },
  apollo: {
    objectTypeMeta: {
      query: gql`
        query ObjectTypeMeta {
          objectTypes {
            objectType
            namePlural
            gqlName
          }
        }
      `,
      update: data => keyBy(data.objectTypes, meta => meta.gqlName),
    },
    mappings: {
      query: gql`
        query MappingsObjectTypes($objectType: SearchType!) {
          objectType(name: $objectType) {
            attrs {
              name
              displayName
              isMapping
            }
          }
        }
      `,
      variables() {
        return {
          objectType: this.objectType,
        };
      },
      update(data) {
        return filter(data.objectType.attrs, 'isMapping');
      },
    },
    tabsList: {
      query() {
        return SorTreeView(this.objectType, this.mappings);
      },
      variables() {
        return {
          objectId: this.objectId,
          objectType: this.objectType,
          mappings: this.mappings,
        };
      },
      update(data) {
        const meta = this.objectTypeMeta;
        return flow(
          data => data.node.relevant,
          mappings => pickBy(mappings, mapping => mapping.totalCount > 0),
          mappings =>
            map(mappings, (mapping, key) => ({
              displayName: meta[key].namePlural,
              objectType: meta[key].objectType,
              totalCount: mapping.totalCount,
            })),
          mappings => sortBy(mappings, mapping => mapping.displayName)
        )(data);
      },
      skip() {
        return !this.mappings;
      },
    },
  },
});
